import { HStack } from "@chakra-ui/react";
import React from "react";
import { RenderRowActionsResult } from "shared/components/table/data/DataTableTypes";
import { MaybernTableRowMenu } from "shared/components/table/maybern/MaybernTableRowMenu";

export const DataTableRowActions: React.FC<
  React.PropsWithChildren<{
    rowActions: RenderRowActionsResult;
  }>
> = ({ rowActions }) => {
  if (!rowActions.actions) {
    return null;
  }
  return (
    <HStack
      className="mb-datatable-row-actions"
      pointerEvents="all"
      alignItems="center"
      justifyContent="flex-end"
      onClickCapture={(e) => {
        e.preventDefault();
      }}
    >
      {rowActions.type === "menu" && (
        <MaybernTableRowMenu>{rowActions.actions}</MaybernTableRowMenu>
      )}
      {rowActions.type === "buttons" ? rowActions.actions : null}
    </HStack>
  );
};
